module.exports = __webpack_public_path__ + "static/media/creditCard.0360a2f9.svg";